import * as React from 'react';
import ReactDOM from "react-dom";
import "./services/firebase";

import {App} from "./pages/App";

ReactDOM.render(<App />, document.getElementById("app"));